import { context, trace } from "@opentelemetry/api";
import { checkIfNodeIsParentInChildArray, findFromIndex, generateNewLid, handleSingleRowShift, handleWholeTreeShift, isParentChildConflict, validateNewLid } from "../../helper/helperFunctions";
import { logSpan } from "../../../../helpers/loggingHelper";

const tracer = trace.getTracer('drag-operations')

export const handleRowDragOperation = async ({
    draggedNode,
    dragStartIndex,
    dragOverIndex,
    overNode,
    gridRef,
    renderAlert,
    setUndoStack,
    predecessorcolumn,
    direction,
    setOperationInProcess,
    prefixl_idForUndo
}: {
    draggedNode: any; 
    dragStartIndex: number;
    dragOverIndex: number;
    overNode: any;
    gridRef: any;
    renderAlert: (message: string, type: 'error' | 'success') => void;
    setUndoStack: (rows: any[]) => void;
    predecessorcolumn: any;
    direction: 'up' | 'down' | null;
    setOperationInProcess: (flag: boolean) => void;
    prefixl_idForUndo:string
})  :Promise<{dropIndex:number,undoInfo:Object,collapseDraggedNode?: boolean;} > => {
    return tracer.startActiveSpan("handleRowDragOperation", async (span) => {
    let functionFlow = ["handleRowDragOperation start"]
    try {
        
        let currentSheetRows = gridRef.current.api.getModel().rowsToDisplay;
        let rid = draggedNode.data.id;

        let fromIndex = findFromIndex(currentSheetRows, dragStartIndex, rid);
        if (fromIndex === -1) throw new Error("ID not found in current sheet rows.");

        let overIndex = dragOverIndex;
        let l_idForUndo = draggedNode.data.l_id.includes('.')
            ? draggedNode.data.l_id.split('.').slice(0, -1).join('.')
            : "";
            
        const isDropOnNode =
            overNode &&
            overNode.data &&
            (
                overNode.expanded ||
                overNode.allChildrenCount > 0
            );
        let prefixlid = "";


        if (prefixl_idForUndo) {
            prefixlid = prefixl_idForUndo;
        }
        else if (isDropOnNode && overNode?.data?.l_id && overIndex) {
            //  Always make child of the node itself
            const node = direction === 'up' ? currentSheetRows[overIndex - 1] : currentSheetRows[overIndex + 1];
            let collapsedNode = node.data.collapsed
            const overLid = node.data.l_id
            prefixlid = (direction === 'down' && node.allChildrenCount < 0 && !collapsedNode) || (direction === 'up' && (node.allChildrenCount > 0 && !collapsedNode)) ? overLid : overLid.includes(".")
                ? overLid.split(".").slice(0, -1).join(".")
                : "";
        }
        else {
            const overRow = currentSheetRows[overIndex];
            if (!overRow) {
                prefixlid = "";
            }
            else {
                const overLid = overRow.data.l_id;
                const isRoot = !overLid.includes(".");
                const isLastRow = overIndex === currentSheetRows.length - 1;

                //  Dropped at end of another tree → child of that tree root
                if (isRoot && isLastRow) {
                    prefixlid = overLid;
                } else {
                    //  Normal sibling logic
                    prefixlid = overLid.includes(".")
                        ? overLid.split(".").slice(0, -1).join(".")
                        : "";
                }
            }
        }

        if (!prefixlid && overNode?.data?.l_id) {
            console.warn("Unexpected empty prefix on drop", overNode.data);
        }

        if (isParentChildConflict(prefixlid, currentSheetRows[fromIndex].data)) {
            renderAlert("Parent cannot be moved into child", "error");
            functionFlow.push(`Parent cannot be moved into child error`)
            gridRef.current.api.redrawRows();
            setOperationInProcess(false);
            return {dropIndex:-1,undoInfo: ''}
        }
        
        let newl_id = generateNewLid(prefixlid, currentSheetRows[fromIndex].data);
        if (!validateNewLid(newl_id, currentSheetRows[fromIndex].data, gridRef)) {
            gridRef.current.api.redrawRows();
            setOperationInProcess(false);
            return {dropIndex:-1,undoInfo: '', collapseDraggedNode: false}
                }
        
        functionFlow.push(`Valid l_id`)
        let undoRows = [currentSheetRows[fromIndex].data];
        let shiftParams = {
            fromIndex,
            currentSheetRows,
            prefixlid,
            gridRef,
            overIndex,
            setUndoStack,
            dragStartIndex,
            undoRows,
            predecessorcolumn,
            overNodeId:overNode.id,
            l_idForUndo
        };

        let returnedParameters;
        if (checkIfNodeIsParentInChildArray(currentSheetRows[fromIndex])) {
            functionFlow.push(`handleWholeTreeShift called`)
            returnedParameters = await handleWholeTreeShift({ ...shiftParams, direction });
        } else {
            functionFlow.push(`handleSingleRowShift called`)
            returnedParameters = await handleSingleRowShift({
                ...shiftParams,
                direction,
                rowsToUpdate: [{
                    ...currentSheetRows[fromIndex].data,
                    l_id: newl_id
                }]
            });
        }
        functionFlow.push("handleRowDragOperation end")
        return {
            dropIndex: returnedParameters.dropIndex,
            undoInfo: returnedParameters.undoInfo,
            ...(returnedParameters.collapseDraggedNode !== undefined && {
              collapseDraggedNode: returnedParameters.collapseDraggedNode
            })
          };
    } catch (error) {
        functionFlow.push("handleRowDragOperation error")
        logSpan("handleRowDragOperation-error", span?.spanContext(), "ERROR", error)
        console.error(error);
        return  {dropIndex:-1,undoInfo: ''};
    }finally{
        functionFlow.push("handleRowDragOperation finally");
        span?.setAttribute("handleRowDragOperation-functionFlow", functionFlow);
        span.end();
    }
    })
};
 